const SENSITIVE_PARAMS = new Set([
  "oobcode",
  "mode",
  "apikey",
  "token",
  "code",
  "continueurl",
  "state",
  "id_token",
  "access_token",
]);

/** True when the query carries a code or token the pixel must not report. */
export const hasSensitiveSearch = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return Array.from(params.keys()).some((key) => SENSITIVE_PARAMS.has(key.toLowerCase()));
};

/** Path plus query for analytics, with codes and auth tokens removed. */
export const analyticsPath = (pathname: string, search: string): string => {
  const params = new URLSearchParams(search);
  Array.from(params.keys()).forEach((key) => {
    if (SENSITIVE_PARAMS.has(key.toLowerCase())) params.delete(key);
  });
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};
